import { render } from "./TestBarChart.vue?vue&type=template&id=26870b2f&scoped=true"
import script from "./TestBarChart.vue?vue&type=script&lang=js"
export * from "./TestBarChart.vue?vue&type=script&lang=js"

import "./TestBarChart.vue?vue&type=style&index=0&id=26870b2f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26870b2f"]])

export default __exports__